<template>
  <v-card elevation="0" outlined class="border-px">
    <v-card-title :class="tableHeaderClass" class="white--text py-3">
      <v-row justify="space-between" :class="isVariableTable ? 'text-caption' : 'subtitle-1 pt-1'"
             class=" font-weight-bold">
        <v-col cols="8" class="d-flex flex-column py-1">
          <span>
            {{ quantityTableTimeRange }}
          </span>
          <span>{{ clientInfo.name }}</span>
        </v-col>
        <v-col cols="4" class="text-end d-flex flex-column py-1">
          <span>{{ isTransitionTable ? "Tabla de Transición" : quantityTable.label }}</span>
          <span>Nivel {{ quantityTable.level + quantityTable.tableClass }} |
            ${{ quantityTable.priceMxn.toFixed(2) }}</span>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="py-3">
      <v-row>
        <v-col cols="4">
          <v-list-item class="ps-0">
            <v-list-item-content class="py-0">
              <v-list-item-title class="text--primary font-weight-bold text-center">
                Peso inicial
              </v-list-item-title>
              <v-list-item-subtitle class="text-center">
                {{ clientInfo.initialWeightKg.toFixed(3) }} kg
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="ps-0">
            <v-list-item-content class="py-0">
              <v-list-item-title class="text--primary font-weight-bold text-center">
                Peso perdido
              </v-list-item-title>
              <v-list-item-subtitle class="text-center">
                {{ (clientInfo.initialWeightKg - quantityTable.clientCurrentWeightKg).toFixed(3) }} kg
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="4">
          <v-list-item class="ps-0">
            <v-list-item-content class="py-0">
              <v-list-item-title class="text--primary font-weight-bold text-center">
                Peso actual
              </v-list-item-title>
              <v-list-item-subtitle class="text-center">
                {{ quantityTable.clientCurrentWeightKg.toFixed(3) }} kg
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="ps-0">
            <v-list-item-content class="py-0">
              <v-list-item-title class="text--primary font-weight-bold text-center">
                Peso ideal
              </v-list-item-title>
              <v-list-item-subtitle class="text-center">
                {{ (Math.round(clientInfo.idealWeightKg * 10) / 10).toFixed(3) }} kg
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="4" align-self="center" class="text-center d-flex flex-column">
          <span class="text--primary">
            {{ weightMessage }}
          </span>
          <span class="text--primary">
            {{ randomMotivationalMessage }}
          </span>
        </v-col>
        <v-col cols="12" class="text-center pt-0" v-if="!isVariableTable">
          <span class="text--primary">
            Debes ingerir diariamente los gramos exactos de tus alimentos de la siguiente manera:
          </span>
        </v-col>
      </v-row>

      <!-- Vacation and extraordinary table -->
      <v-row v-if="isVacationTable" no-gutters justify="space-between" class="mt-2">
        <v-col cols="12">
          <v-simple-table dense>
            <thead>
            <tr :class="tableHeaderClass">
              <th class="white--text text-start" style="width: 224px">DÍA</th>
              <th class="white--text text-center">DESAYUNO</th>
              <th class="white--text text-center">SNACK</th>
              <th class="white--text text-center">COMIDA</th>
              <th class="white--text text-center">SNACK</th>
              <th class="white--text text-center">CENA</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(detail, index) in quantityTable.quantityTableDetails"
                :key="index"
                :class="tableRowClass(index, detail.dayNumber)"
            >
              <td class="text-start font-weight-medium">
                <div class="d-flex align-center">
                  <v-simple-checkbox disabled></v-simple-checkbox>
                  {{ detail.dayName }} {{ detail.dayNumber || "" }}
                </div>
              </td>
              <td class="text-center font-weight-bold">
                {{ detail.breakfastGrams }} g
              </td>
              <td class="text-center font-weight-bold">
                {{ quantityTable.morningSnack }} g
              </td>
              <td class="text-center font-weight-bold">
                {{ detail.lunchGrams }} g
              </td>
              <td class="text-center font-weight-bold">
                {{ quantityTable.eveningSnack }} g
              </td>
              <td class="text-center font-weight-bold">
                {{ detail.dinnerGrams }} g
              </td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>

      <!-- ABC Table -->
      <v-row v-else-if="quantityTable.type === 'ABC'" class="mt-2">
        <v-col cols="12" class="pt-0">
          <v-row no-gutters justify="space-between" :class="quantityTable.primaryColor + ' accent-1'"
                 class="rounded-xl">
            <v-col cols="12" sm="2" align-self="center">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="text--primary font-weight-bold text-center">
                    <span>ORIGEN</span>
                    <br>
                    <span>ANIMAL</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" sm="2">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="text--primary font-weight-bold text-center">
                    DESAYUNO
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-center text-h6">
                    {{ quantityTable.quantityTableDetails[0].breakfastGrams }} g
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" sm="2">
              <v-list-item class="px-0">
                <v-list-item-content class="relocated-text rounded-xl white">
                  <v-list-item-title class="text--primary font-weight-bold text-center">
                    SNACK
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-center text-h6">
                    {{ quantityTable.morningSnack || 0 }} g
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" sm="2">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="text--primary font-weight-bold text-center">
                    COMIDA
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-center text-h6">
                    {{ quantityTable.quantityTableDetails[0].lunchGrams }} g
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" sm="2">
              <v-list-item class="px-0">
                <v-list-item-content class="relocated-text rounded-xl white">
                  <v-list-item-title class="text--primary font-weight-bold text-center">
                    SNACK
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-center text-h6">
                    {{ quantityTable.eveningSnack || 0 }} g
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" sm="2">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="text--primary font-weight-bold text-center">
                    CENA
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-center text-h6">
                    {{ quantityTable.quantityTableDetails[0].dinnerGrams }} g
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row no-gutters justify="space-between" :class="quantityTable.secondaryColor" class="rounded-xl mt-2">
            <v-col cols="12" sm="2" align-self="center">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="text--primary font-weight-bold text-center">
                    <span>ORIGEN</span>
                    <br>
                    <span>VEGETAL</span>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="12" sm="2">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="text--primary font-weight-bold text-center">
                    DESAYUNO
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-center text-h6">
                    {{ quantityTable.quantityTableDetails[1].breakfastGrams }} g
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="2">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="text--primary font-weight-bold text-center">
                    COMIDA
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-center text-h6">
                    {{ quantityTable.quantityTableDetails[1].lunchGrams }} g
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="2">
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title class="text--primary font-weight-bold text-center">
                    CENA
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-center text-h6">
                    {{ quantityTable.quantityTableDetails[1].dinnerGrams }} g
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row no-gutters justify="space-between" class="mt-2">
            <v-spacer></v-spacer>
            <v-col cols="12" sm="2">
              <v-list-item dense class="px-0">
                <v-list-item-content>
                  <v-list-item-subtitle class="text-center font-weight-bold">
                    TOTAL
                    {{
                      quantityTable.quantityTableDetails[0].breakfastGrams +
                      quantityTable.quantityTableDetails[1].breakfastGrams
                    }} g
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="2">
              <v-list-item dense class="px-0">
                <v-list-item-content>
                  <v-list-item-subtitle class="text-center font-weight-bold">
                    TOTAL
                    {{
                      quantityTable.quantityTableDetails[0].lunchGrams +
                      quantityTable.quantityTableDetails[1].lunchGrams
                    }} g
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" sm="2">
              <v-list-item dense class="px-0">
                <v-list-item-content>
                  <v-list-item-subtitle class="text-center font-weight-bold">
                    TOTAL
                    {{
                      quantityTable.quantityTableDetails[0].dinnerGrams +
                      quantityTable.quantityTableDetails[1].dinnerGrams
                    }} g
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- Variable table -->
      <v-row v-else-if="isVariableTable" no-gutters justify="space-between" class="mt-2">
        <v-col cols="12">
          <v-simple-table dense>
            <thead>
            <tr :class="tableHeaderClass">
              <th class="white--text text-start" style="width: 164px">DÍA</th>
              <th class="white--text text-center">DESAYUNO</th>
              <th class="white--text text-center">SNACK</th>
              <th class="white--text text-center">COMIDA</th>
              <th class="white--text text-center">SNACK</th>
              <th class="white--text text-center">CENA</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(detail, index) in quantityTable.quantityTableDetails"
                :key="index"
                :class="index % 2 === 0 ? `${quantityTable.secondaryColor} lighten-5` : 'white'"
            >
              <td class="text--primary text-start font-weight-medium">
                <div class="d-flex align-center">
                  <v-simple-checkbox disabled></v-simple-checkbox>
                  {{ detail.dayName }} {{ detail.dayNumber }}
                </div>
              </td>
              <td class="text--primary text-center font-weight-bold">
                {{ detail.breakfastGrams }} g
              </td>
              <td class="text--primary text-center font-weight-bold">
                {{ quantityTable.morningSnack }} g
              </td>
              <td class="text--primary text-center font-weight-bold">
                {{ detail.lunchGrams }} g
              </td>
              <td class="text--primary text-center font-weight-bold">
                {{ quantityTable.eveningSnack }} g
              </td>
              <td class="text--primary text-center font-weight-bold">
                {{ detail.dinnerGrams }} g
              </td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-col>
      </v-row>

      <!-- Default table -->
      <v-row v-else no-gutters justify="space-between" class="rounded-xl mt-3"
             :class="isTransitionTable ? 'blue lighten-5' : quantityTable.primaryColor + ' lighten-5'">
        <v-col cols="12" sm="2">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title class="text--primary font-weight-bold text-center">
                DESAYUNO
              </v-list-item-title>
              <v-list-item-subtitle class="text-center text-h6">
                {{ quantityTable.quantityTableDetails[0].breakfastGrams }} g
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="2">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title class="text--primary font-weight-bold text-center">
                SNACK
              </v-list-item-title>
              <v-list-item-subtitle class="text-center text-h6">
                {{ quantityTable.morningSnack || 0 }} g
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="2">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title class="text--primary font-weight-bold text-center">
                COMIDA
              </v-list-item-title>
              <v-list-item-subtitle class="text-center text-h6">
                {{ quantityTable.quantityTableDetails[0].lunchGrams }} g
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="2">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title class="text--primary font-weight-bold text-center">
                SNACK
              </v-list-item-title>
              <v-list-item-subtitle class="text-center text-h6">
                {{ quantityTable.eveningSnack || 0 }} g
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" sm="2">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-title class="text--primary font-weight-bold text-center">
                CENA
              </v-list-item-title>
              <v-list-item-subtitle class="text-center text-h6">
                {{ quantityTable.quantityTableDetails[0].dinnerGrams }} g
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <span :class="isVariableTable ? 'text-caption' : 'subtitle-1'" class="font-weight-bold subtitle-1">
        DIETEC SDR
      </span>
      <v-spacer></v-spacer>
      <span :class="isVariableTable ? 'text-caption' : 'subtitle-1'" class="font-weight-bold subtitle-1">
        Visítanos en www.dietec.mx
      </span>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import Vue from "vue";

import {QuantityTableInfo} from "@/services/quantityTables/entities/QuantityTableInfo";
import {ClientTableInfo} from "@/services/clients/entities/ClientTableInfo";

export default Vue.extend({
  name: "QuantityTable",
  props: {
    quantityTable: {
      type: Object as () => QuantityTableInfo,
      required: true,
    },
    clientInfo: {
      type: Object as () => ClientTableInfo,
      required: true,
    },
  },
  data() {
    return {
      //
    }
  },
  computed: {
    tableHeaderClass(): string {
      if (this.isTransitionTable) {
        return 'blue'
      }
      if (this.quantityTable.type === 'ABC') {
        return `${this.quantityTable.primaryColor} darken-3`
      }
      if (this.isVariableTable) {
        return this.quantityTable.secondaryColor
      }
      return this.quantityTable.primaryColor
    },
    isLostWeight(): boolean {
      return this.quantityTable.lostWeightKg < 0;
    },
    weightMessage(): string {
      if (this.isMaintenanceTable) {
        return `¡Felicidades por haber bajado ${(this.clientInfo.initialWeightKg - this.quantityTable.clientCurrentWeightKg).toFixed(3)} kilogramos!`;
      }
      let weightChangeMessage = "";
      const weightDiff = this.quantityTable.lostWeightKg;
      if (this.quantityTable.level !== 1) {
        if (weightDiff === 0) {
          weightChangeMessage = 'No subiste ni bajaste. ';
        } else {
          const action = weightDiff > 0 ? "Subiste" : "Bajaste";
          const absWeight = Math.abs(weightDiff);
          if (absWeight < 1) {
            weightChangeMessage = `${action} ${(absWeight * 1000).toFixed(0)} g. `;
          } else {
            weightChangeMessage = `${action} ${absWeight.toFixed(3)} kg. `;
          }
        }
      }
      const goalToIdealWeightMessage = this.clientInfo.idealWeightKg >= this.quantityTable.clientCurrentWeightKg ?
          "¡Has alcanzado tu peso ideal!" :
          `Estás a ${(this.quantityTable.clientCurrentWeightKg - (Math.round(this.clientInfo.idealWeightKg * 10) / 10)).toFixed(3)} kg de tu peso ideal. `;
      return weightChangeMessage + goalToIdealWeightMessage;
    },
    randomMotivationalMessage(): string {
      const level1Messages = [
        "¡Empieza tu transformación hoy!",
        "Cada paso cuenta hacia tu meta.",
        "¡Tú puedes lograrlo!",
        "La constancia es la clave del éxito.",
        "Transforma tu vida, un día a la vez.",
        "¡Empieza hoy con entusiasmo!",
        "El cambio ocurre cuando decides iniciarlo.",
        "Hoy es el día perfecto para comenzar.",
        "¡Tu viaje ha comenzado!",
        "Cada pequeño esfuerzo suma grandes resultados.",
        "El primer paso ya es un gran logro.",
        "¡Da el primer paso hacia tu mejor versión!",
        "Pequeños pasos, grandes cambios.",
      ];
      const lostWeightMessages = [
        "¡Increíble progreso!",
        "Tu esfuerzo está dando frutos.",
        "¡Estás haciendo un gran trabajo!",
        "¡Estás más cerca de tu meta!",
        "¡Sigue así!",
        "Celebra cada logro en tu camino.",
        "Tu dedicación y esfuerzo son admirables.",
        "Tu progreso se refleja en cada paso.",
        "Mírate al espejo, ¡lo estás logrando!",
        "Cada paso te acerca a tu mejor versión.",
        "Cree en ti, sé constante y no te rindas.",
        "¡Tu determinación es inspiradora!",
        "Sigue adelante, lo mejor está por venir.",
        "¡Estás haciendo un trabajo increíble!",
        "Agradece a tu cuerpo por todo.",
        "Estás más cerca de tu meta.",
        "¡Eres imparable!",
        "Cada paso vale la pena.",
        "¡Tu progreso es real!",
        "¡Muy bien hecho!",
        "Cada gramo es una victoria.",

      ];
      const gainedWeightMessages = [
        "¡Vamos, tú puedes hacerlo!",
        "Cada día es una nueva oportunidad.",
        "¡No te rindas!",
        "¡Sigue luchando por tus objetivos!",
        "La perseverancia te llevará al éxito.",
        "La constancia es tu mejor aliada.",
        "Una recaída no es el final, ¡sigue adelante!",
        "Cada día es una nueva oportunidad.",
        "Recuerda por qué comenzaste este viaje.",
        "¡Tú tienes el control de tu camino!",
        "No te desanimes, cada paso cuenta.",
        "Sé amable contigo y sigue adelante.",
        "¡Tu esfuerzo vale la pena!",
        "¡Cree en tu capacidad de cambio!",
        "Tu esfuerzo vale más que un número.",
        "Esto también es parte del proceso.",
        "¡Vuelve con más fuerza!",
        "Respira y sigue adelante.",
        "¡Tú puedes con esto!",
      ];
      const maintenanceMessages = [
        "¡Mantenerse es también un gran logro!",
        "Sigue cuidando de ti.",
        "Recuerda que la moderación es clave.",
        "Recuerda el esfuerzo que te llevó hasta aquí.",
        "¡Disfruta de tu nuevo estilo de vida saludable!",
        "Celebra tu constancia y dedicación.",
        "Es momento de mantenerte constante.",
        "¡Tu disciplina es admirable!",
        "Recuerda el camino que has recorrido.",
        "¡Sigue brillando con salud!",
      ];

      let messages = this.quantityTable.level === 1
          ? level1Messages
          : this.isLostWeight
              ? lostWeightMessages
              : gainedWeightMessages;
      if (this.isMaintenanceTable) messages = maintenanceMessages;
      const randomIndex = Math.floor(Math.random() * messages.length);
      return messages[randomIndex];
    },
    isVariableTable(): boolean {
      return (this.quantityTable.type === 'WEEKLY' ||
              this.quantityTable.type === 'WEEKLY_PLUS' ||
              this.quantityTable.type === 'WEEKLY_N2') &&
          this.quantityTable.level % 2 === 0;
    },
    isVacationTable(): boolean {
      return this.quantityTable.type === 'VACATION' ||
          this.quantityTable.type === 'EXTRA';
    },
    isTransitionTable(): boolean {
      if (this.quantityTable.level < 9) return false;
      if (this.quantityTable.type !== 'WEEKLY' && this.quantityTable.type !== 'WEEKLY_PLUS') return false;
      return (this.quantityTable.level - 9) % 8 === 0;
    },
    isMaintenanceTable(): boolean {
      return this.quantityTable.type === 'MAINTENANCE' || this.quantityTable.type === 'CONTROL';
    },
    quantityTableTimeRange(): string {
      if (this.quantityTable.type === 'CONTROL') return "Usa diario esta tabla para mantener tu peso actual";
      if (this.quantityTable.type === 'MAINTENANCE') return "Usa la tabla por una semana cuando subas 1 kg";

      const parseLocalDate = (dateStr: string) => {
        const [year, month, day] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day);
      };

      const startDate = parseLocalDate(this.quantityTable.createdAt);
      const endDate = parseLocalDate(this.quantityTable.expiresAt);

      const optionsStart: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        weekday: 'long',
      };
      const optionsEnd: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        weekday: 'long',
      };
      const optionsMonthYear: Intl.DateTimeFormatOptions = {
        month: 'long',
        year: 'numeric',
      };

      const startDateStr = startDate.toLocaleDateString('es-MX', optionsStart);
      const endDateStr = endDate.toLocaleDateString('es-MX', optionsEnd);

      const sameDay = endDate.getDate() === startDate.getDate();

      return `${this.capitalize(startDateStr)} - ${this.capitalize(endDateStr)} ${
          !sameDay ? 'de ' + endDate.toLocaleDateString('es-MX', optionsMonthYear) : ''
      }`;
    },
  },
  methods: {
    capitalize(str: string): string {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    tableRowClass(index: number, dayNumber: number | null): string {
      if (!dayNumber) {
        return `${this.quantityTable.primaryColor} lighten-3`;
      }
      return index % 2 === 0 ? `${this.quantityTable.primaryColor} lighten-5` : 'white';
    }
  }
});
</script>

<style scoped>
.relocated-text {
  position: relative;
  top: 38px;
}

.border-px {
  border-width: 2px !important;
}
</style>